import { render, staticRenderFns } from "./Stagione.vue?vue&type=template&id=35b58375&scoped=true&"
import script from "./Stagione.vue?vue&type=script&lang=js&"
export * from "./Stagione.vue?vue&type=script&lang=js&"
import style0 from "./Stagione.vue?vue&type=style&index=0&id=35b58375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b58375",
  null
  
)

export default component.exports